<template>  
    <div class="row filter_row_parent">
        
        <div v-if="options"  class="col-md-12 d-flex pt-3">
            <span class="filter_title mb-3" v-if="filter.name != 'fastship'">{{ filter.label }}</span>
            <div class="ques_pop">
                <ModalLooseReport v-if="filter.name === 'report'" />
                <ModalLooseBlockChain v-if="filter.name === 'blockchain'" />
              
            </div>
        </div>
        <div  class="col-md-12 ">
            <div class="shape_flex">
               
            <div class="filter_row">
                <div class="checkbox_custom" @click="change(option)" v-for="option in options" :key="option.value">
                    <span :class="{ 'checked' : option.active === 1,  'unchecked' : option.active === 0 }"></span>
                    <label class="mb-0">{{option.label}}</label>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {cyolistStore}  from '@/stores/cyolist/cyolist'
    const store = cyolistStore();
    const props = defineProps(['name'])
    const moduleSubType = inject('moduleSubType')

    const filter = computed(() => store.getSettingFilter(moduleSubType, props.name))
    const options = computed(() => store.getSettingFilterOptions(moduleSubType, props.name))
  
    const change = (option) => {
        if (option.disabled) {
            return
        }
        store.toggleSettingFilter( { reset: false, type: moduleSubType, filter: filter.value, option } )
    }
</script>
 
<style scoped>
.center_col {
    padding: 0 2% !important;
}
.left_col {
    padding-right: 2% !important;
}
.right_col {
    padding-left: 2% !important;
}
.checkbox_custom{
    margin-right: 15px;
    margin-left: 0;
}
.ques_pop {
    margin-top: -2px;
}
@media(max-width: 992px){
    .filterbox img {
        width: 25px;
    }
    .filterbox{
        width: 36px !important;
        height: 36px !important;
        margin: 0 1% 1% 0 !important;
    }
    .center_col {
        padding: 0 2% !important;
        height: 90px;
        margin: 0 !important;
    }
    .left_col {
        padding: 0 2% !important;
        height: 90px;
        margin: 0 !important;
    }
    .right_col {
        padding: 0 2% !important;
        height: 90px;
        margin: 0 !important;
    } 
}

@media(max-width: 767px){
  
}
.filterbox {
    width: 45px;
    height: 45px;
    border: solid 1px #c6cbd4;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 3% 3% 0;
    cursor: pointer;
}
.filterbox.active {
    border: 1px solid var(--green);
}
.filter_row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
span.filter_title {
    color: #333333;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: normal;
}
.input-group input {
    border: 1px solid #c6cbd4;
    border-radius: 0;
    height: 30px;
    max-width: 100px;
    font-size: 14px;
}
</style>
